import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';
// Add this import:
import { AppContainer } from 'react-hot-loader';
import { ToastContainer } from "react-toastify";
import { LocaleProvider } from "antd";
import './index.scss'
// Wrap the rendering in a function:

const render = Component => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });


    ReactDOM.render(
        // Wrap App inside AppContainer

        <AppContainer>
            <div className='temx-main-div-first' style={{ overflow: 'auto', direction: 'ltr' }}>
                <div className='for-scroll'>
                    <NextApp />

                </div>
            </div>
        </AppContainer>,
        document.getElementById('root')
    );
};


// Render once
render(NextApp);

// Webpack Hot Module Replacement API
